export default __webpack_public_path__ + "static/media/logo-card-1440w.0a6c76bf.avif";